import './style.scss';
import bando from '../../assets/bando.png';
export default function Bando(){
    return <div id='containerBando'>

<div className="marquee-rtl">
<img className="defile" id="txtBando" src={bando} alt="bando"/>
      </div>

</div>
}




